import React from "react";
import moment from "moment";

import { fetchApi } from "../../Network/NetworkService";
import { notif } from "../Ui/Notification";

import "../../Assets/Pages/dermatoSdr.css";
import IconTooltip from "../Ui/IconTooltip";

// Patients qui ont reçu le mail de consentement WhatsApp (campagne manuelle
// ou invitation automatique J+3) PUIS activé les notifications. Lecture
// seule : le consentement est écrit par feeli-server quand le patient valide
// la page /notifications-whatsapp (source « email-optin ») ou coche la case
// de son profil.
const SOURCE_LABELS = {
  "email-optin": "Email d'invitation",
  profile: "Profil patient",
  dashboard: "Espace patient",
};

class WhatsappOptinActivations extends React.Component {
  constructor() {
    super();
    this.state = {
      // 'invited' = invité par l'email PUIS activé ; 'all' = tous les
      // whatsappOptIn true, quelle qu'en soit l'origine.
      view: "invited",
      users: [],
      loading: false,
      loaded: false,
      page: 1,
      totalPage: 0,
      countUsers: 0,
      invitedCount: 0,
      activatedCount: 0,
      consentedCount: 0,
    };
  }

  componentDidMount() {
    this.fetchActivations();
  }

  fetchActivations = () => {
    this.setState({ loading: true });
    fetchApi(
      "/whatsapp-optin/activations?page=" +
        this.state.page +
        "&view=" +
        this.state.view,
    )
      .then((res) => {
        this.setState({
          users: res.users || [],
          totalPage: res.countPages || 0,
          countUsers: res.countUsers || 0,
          invitedCount: res.invitedCount || 0,
          activatedCount: res.activatedCount || 0,
          consentedCount: res.consentedCount || 0,
          loaded: true,
          loading: false,
        });
      })
      .catch(() => {
        notif.addNotification(
          "Erreur",
          "Erreur de récupération des activations",
          "warning",
        );
        this.setState({ loading: false });
      });
  };

  setView = (view) => {
    if (view === this.state.view) return;
    this.setState(
      { view, users: [], page: 1, loading: true },
      this.fetchActivations,
    );
  };

  updatePage(page) {
    this.setState({ users: [], page, loading: true }, this.fetchActivations);
  }

  render() {
    const {
      view,
      users,
      loading,
      loaded,
      page,
      totalPage,
      countUsers,
      invitedCount,
      activatedCount,
      consentedCount,
    } = this.state;
    const rate =
      invitedCount > 0 ? Math.round((activatedCount / invitedCount) * 100) : 0;

    return (
      <div className="dermato-sdr-container">
        <div className="dermato-sdr-header">
          <h2 className="dermato-sdr-title">
            {"Activations — Opt-in WhatsApp"}
          </h2>
          <button
            className="dermato-sdr-btn dermatosdr-btn-link"
            onClick={() => this.props.history.push("/whatsapp-optin")}
          >
            {"← Retour aux envois"}
          </button>
        </div>

        <div className="dermato-sdr-card">
          <div className="dermato-sdr-inline" style={{ marginBottom: 8 }}>
            <button
              className={
                "dermato-sdr-btn " +
                (view === "invited"
                  ? "dermatosdr-btn-primary"
                  : "dermatosdr-btn-link")
              }
              onClick={() => this.setView("invited")}
            >
              {"Activés après invitation (" + activatedCount + ")"}
            </button>
            <button
              className={
                "dermato-sdr-btn " +
                (view === "all"
                  ? "dermatosdr-btn-primary"
                  : "dermatosdr-btn-link")
              }
              onClick={() => this.setView("all")}
            >
              {"Tous les consentants (" + consentedCount + ")"}
            </button>
          </div>
          <h3 className="dermato-sdr-card-title">
            {view === "all"
              ? "Patients avec consentement WhatsApp"
              : "Patients ayant activé après invitation"}{" "}
            ({countUsers})
          </h3>
          {view === "all" ? (
            <p style={{ color: "#888", fontSize: 14, marginTop: -8 }}>
              {consentedCount}
              {" patients ont whatsappOptIn actif, dont seulement "}
              <strong>{activatedCount}</strong>
              {" passés par l'email d'invitation. Les colonnes « Activé le » et « Via » tracent l'origine de chaque consentement : « (aucune source) / — » = consentement non traçable, probablement posé en masse."}
            </p>
          ) : (
            <p style={{ color: "#888", fontSize: 14, marginTop: -8 }}>
              {invitedCount} {"invités au total → "}
              <strong style={{ color: "#2e7d32" }}>
                {activatedCount} {"activations"}
              </strong>
              {" ("}
              {rate}
              {" %). Le consentement est donné par le patient lui-même ; il peut le retirer à tout moment."}
            </p>
          )}

          {loading ? (
            <div className="dermato-sdr-empty">
              <span className="loader" />
            </div>
          ) : loaded && users.length === 0 ? (
            <div className="dermato-sdr-empty">
              {view === "all"
                ? "Aucun patient consentant."
                : "Aucune activation pour le moment."}
            </div>
          ) : users.length > 0 ? (
            <div>
              <table className="dermato-sdr-table">
                <thead>
                  <tr>
                    <th>Nom</th>
                    <th>Email</th>
                    <th>{"Téléphone"}</th>
                    <th>{"Email envoyé le"}</th>
                    <th>{"Activé le"}</th>
                    <th>Via</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((u) => (
                    <tr key={u._id}>
                      <td>
                        {u.FName} {u.LName}
                      </td>
                      <td>{u.email}</td>
                      <td>{u.phone || "—"}</td>
                      <td>
                        {u.whatsappOptInEmailSentAt
                          ? moment(u.whatsappOptInEmailSentAt).format(
                              "DD/MM/YYYY HH:mm",
                            )
                          : "—"}
                      </td>
                      <td style={{ color: "#2e7d32", fontWeight: 600 }}>
                        {u.whatsappOptInAt
                          ? moment(u.whatsappOptInAt).format("DD/MM/YYYY HH:mm")
                          : "—"}
                      </td>
                      <td>
                        {SOURCE_LABELS[u.whatsappOptInSource] ||
                          u.whatsappOptInSource || (
                            <span style={{ color: "#c62828" }}>
                              {"(aucune source)"}
                            </span>
                          )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="dermatosdr-pagination">
                <p style={{ margin: 0, color: "#888", fontSize: 14 }}>
                  Page <strong>{page}</strong> / {totalPage}
                </p>
                <div>
                  {page > 1 && (
                    <IconTooltip
                      icon="fa fa-chevron-left"
                      text="Page précédente"
                      onClick={() => this.updatePage(page - 1)}
                    />
                  )}
                  {page < totalPage && (
                    <IconTooltip
                      icon="fa fa-chevron-right"
                      text="Page suivante"
                      onClick={() => this.updatePage(page + 1)}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default WhatsappOptinActivations;
